<template>
    <el-dialog class="eval-dialog"
               :visible.sync="showPlanOrganDialog"
               :title="planInfo.plan_name"
               :before-close="handleBeforeClose"
               width="500px"
               center>
      <p class="organTitle" v-if="canType !== 'view'"><span style="font-weight:bold;font-size:18px">请输入{{planInfo.plan_level}}级计划开班期数:</span></p>
         <div class="form_content" style="margin-top:20px">
            <el-form ref="form"  :model="form" :rules="rules"  class="form">
                <el-form-item label-width="90px" prop="number_one" label="第一季度" >
                  <el-input-number
                    placeholder="请输入计划开班数量"
                    v-model="form.number_one"
                    class=" input-item-hasmb"
                    style="width:160px"
                    :disabled="canType === 'view'"
                    :min="0"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label-width="90px" prop="number_two" label="第二季度" >
                  <el-input-number
                    placeholder="请输入计划开班数量"
                    v-model="form.number_two"
                    class=" input-item-hasmb"
                    style="width:160px"
                    :min="0"
                    :disabled="canType === 'view'"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label-width="90px" prop="number_three" label="第三季度" >
                  <el-input-number
                    placeholder="请输入计划开班数量"
                    v-model="form.number_three"
                    class=" input-item-hasmb"
                    style="width:160px"
                    :min="0"
                    :disabled="canType === 'view'"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label-width="90px" prop="number_four" label="第四季度" >
                  <el-input-number
                    placeholder="请输入计划开班数量"
                    v-model="form.number_four"
                    class=" input-item-hasmb"
                    style="width:160px"
                    :min="0"
                    :disabled="canType === 'view'"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label-width="90px"  label="共计:" style="font-weight:bold;">
                  <span style="font-weight:bold;">{{form.number_four+form.number_three+form.number_two+form.number_one}} 期</span>
                </el-form-item>
            </el-form>
            <div class="sure" v-if="canType !== 'view'">
                <el-button type="primary" @click="sure_select" :loading="loading" :disabled="loading">
                    确定
                </el-button>
                <el-button type="danger" @click="handleBeforeClose" >
                    取消
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    
    import fiveMixins from "@/minix/fiveMixins";
    import {classPlanYearAdd,classPlanYearEdit,classPlanOrganInfoYear} from "@/api/class_plan/api";
    export default {
        name: "addYearPlan",
      mixins: [fiveMixins],
        data(){
          return{
              form:{
                  number_one:0,
                number_two:0,
                number_three:0,
                number_four:0,
                plan_year_id:0,
              },
              rules:{
                number_one: [
                      { required: true, message: '请输入计划开班数量', trigger: 'blur' }
                  ],
                number_two: [
                      { required: true, message: '请输入计划开班数量', trigger: 'blur' }
                  ],
                number_three: [
                      { required: true, message: '请输入计划开班数量', trigger: 'blur' }
                  ],
                number_four: [
                      { required: true, message: '请输入计划开班数量', trigger: 'blur' }
                  ],
              },
              loading:false
          }
        },
        props:{
            planInfo:{
                type:Object,
                required:true,
            },
            canType:{
                type:String,
                required:true,
                default: 'add',
            },
          org_id:{
                type:Number,
                required:true,
            },
            showdialog:{
                type:Boolean,
                required:true,
            }
        },
      created(){
          if(this.canType === 'edit' || this.canType === 'view'){
            this.getClassPlanOrganInfo();
          }
      },
        methods:{
            sure_select(){
                this.loading=true;
                this.$refs['form'].validate(valid=>{
                    if (valid){
                      let request;
                      let data = {
                        ...this.form,
                        plan_id:this.planInfo.plan_id
                      };
                      if(this.canType === 'edit'){
                        request = classPlanYearEdit;
                        
                      }else{
                        request = classPlanYearAdd;
                        
                      }
                      console.log(data)
                      request(data).then(res => {
                        if(Number(res.data.status) === 0){
                          this.loading=false;
                          this.$message.success('开班计划保存成功');
                          this.$emit('hideTips',true)
                        }else{
                          this.$message.error(res.data.msg)
                          this.loading=false;
                        }
    
                      }).catch(err => {
                        console.log(err);
                        this.loading=false;
                      });
                    }else{
                        this.$message.error('请输入计划开班数量');
                        this.loading=false
                    }
                })
            },
          getClassPlanOrganInfo(){
            classPlanOrganInfoYear({
              plan_id:this.planInfo.plan_id,
              org_id:this.org_id
            }).then(({data}) => {
              if(Number(data.status) === 0){
                this.form = data.result;
                
              }else{
                this.$message.error(res.data.msg);
              }
            });
          },
          handleBeforeClose() {
            this.$emit("update:showdialog", false);
          },
        },
        computed:{
          showPlanOrganDialog:{
                get(){
                    return this.showdialog;
                }
            }
        }
    }
</script>

<style scoped lang="stylus">
    .form_content
        .form
            padding-left: 30px
        .sure
            text-align: center;
</style>
